import { defineComponent as _defineComponent } from 'vue'
import { withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { h, useSlots, reactive } from "vue";
      import { assignSlotNodes, Slots } from "@lit-labs/vue-utils/wrapper-utils.js";
      import '@oicl/openbridge-webcomponents/dist/components/message-menu-item/message-menu-item.js';
      import {ObcMessageMenuItemSize} from '@oicl/openbridge-webcomponents/dist/components/message-menu-item/message-menu-item.js';

      export interface Props {
     size?: ObcMessageMenuItemSize;
     stackVertical?: boolean;
     enhancedIcon?: boolean;
     open?: boolean;
     title?: string;
     description?: string;
     day?: string;
     time?: string;
     primaryActionLabel?: string;
     secondaryActionLabel?: string;
     hasPrimaryIcon?: boolean;
     hasSecondaryIcon?: boolean;
     hasTrailingIcon?: boolean;
     isShelved?: boolean;
     hasActionLabelSlot?: boolean
   }

      
  
      export type {ObcMessageMenuItemSize} from '@oicl/openbridge-webcomponents/dist/components/message-menu-item/message-menu-item.js';
    
export default /*@__PURE__*/_defineComponent({
  __name: 'ObcMessageMenuItem',
  props: {
    size: {},
    stackVertical: { type: Boolean },
    enhancedIcon: { type: Boolean },
    open: { type: Boolean },
    title: {},
    description: {},
    day: {},
    time: {},
    primaryActionLabel: {},
    secondaryActionLabel: {},
    hasPrimaryIcon: { type: Boolean },
    hasSecondaryIcon: { type: Boolean },
    hasTrailingIcon: { type: Boolean },
    isShelved: { type: Boolean },
    hasActionLabelSlot: { type: Boolean }
  },
  emits: ["message-click", "primary-action-click", "secondary-action-click"],
  setup(__props: any, { emit: __emit }) {

      const vueProps = __props;

  const defaults = reactive({} as Props);
  const vDefaults = {
    created(el: any) {
      for (const p in vueProps) {
        defaults[p as keyof Props] = el[p];
      }
    }
  };

  let hasRendered = false;

      const emit = __emit;

      const slots = useSlots() as Slots;

      const render = () => {
        const eventProps = {
    onMessageClick: (event: CustomEvent<{open: boolean}>) => emit('message-click', event as CustomEvent<{open: boolean}>),
onPrimaryActionClick: (event: CustomEvent<void>) => emit('primary-action-click', event as CustomEvent<void>),
onSecondaryActionClick: (event: CustomEvent<void>) => emit('secondary-action-click', event as CustomEvent<void>)
  };
        const props = eventProps as (typeof eventProps & Props);

        
      for (const p in vueProps) {
        const v = vueProps[p as keyof Props];
        if ((v !== undefined) || hasRendered) {
          (props[p as keyof Props] as unknown) = v ?? defaults[p as keyof Props];
        }
      }

      hasRendered = true;
    

        return h(
          'obc-message-menu-item',
          props,
          assignSlotNodes(slots)
        );
      };
    
return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(render, null, null, 512)), [
    [vDefaults]
  ])
}
}

})